import * as types from '../../constants/types';

export function setLoading(status: boolean) {
  return {
    type: types.SET_LOADING,
    payload: status,
  }
}
